import { merge } from '@/utils';
import cfg from './env';

export default merge( {

	version: '2.0.15',

	// These must be filled in otherwise the mapping functionality
	// will not work.
	maptilerAPIKey: 'TeyW8jZ7E5MNwYspUD1h',
	maptilerStyleId: 'uk-openzoomstack-road',

	// In case the EIA Tool BE grows and needs a versioned API,
	// it can easily be switched here. See `@/utils/api-utils`
	// for how this is used.
	apiVersion: 'v1',

	// These must be filled in before deployment.
	// Ensure they match not just the BE API host, but the
	// host definitions in the EIA Tool BE configuration, otherwise
	// you're going to fall afoul of CORS rules, and they're never fun
	//
	// Also, do not use trailing slashes. These are added automatically
	// (see `@/utils/api-utils`).
	endpoints: {

		// this value is used when serving the application locally
		developmentLocal: 'http://localhost:12345',

		development: '',

		// this value is used in /dist when the application is built
		uat: 'https://uat.eiascreening.fdclients.co.uk',

		// this value is used in /dist when the application is built
		production: 'https://www.eiascreening.co.uk',
	},
}, cfg );
